import React from 'react';
import { node, object } from 'prop-types';
import template from 'lodash/template';
import { getRegionalBrandName } from 'utils/domainHelper';

const Tmpl = ({ children, vars = {} }) => {
  const varsDefault = { brand: getRegionalBrandName() };
  vars = { ...varsDefault, ...vars };

  try {
    const compiled = template(children)(vars);
    return <>{compiled}</>;
  } catch (error) {
    console.error('Error compiling template:', error); // eslint-disable-line
    return <>{children}</>;
  }
};

Tmpl.propTypes = {
  children: node.isRequired,
  vars: object,
};

export default Tmpl;
